import type { Network } from '@tribeplatform/gql-client/types'

import { useQuery, UseQueryOptions } from '../../lib/react-query/useQuery.js'
import { useTribeClient } from '../../useTribeClient.js'
import { getNetworkContentModulesKey } from '../../utils/keys/network.key.js'
import { useCachedNetwork } from '../cache/useCachedNetwork.js'

export const useNetworkContentModules = (options?: {
  useQueryOptions?: UseQueryOptions<Network['contentModules']>
  ignorePlaceholderData?: boolean
}) => {
  const { useQueryOptions, ignorePlaceholderData = false } = options || {}
  const { client } = useTribeClient()
  const networkKey = getNetworkContentModulesKey()
  const placeholderData = useCachedNetwork()

  return useQuery<Network['contentModules']>(
    networkKey,
    () => client.network.getContentModules(),
    {
      ...(ignorePlaceholderData
        ? {}
        : { placeholderData: placeholderData?.contentModules }),
      ...useQueryOptions,
    },
  )
}
